import { render, staticRenderFns } from "./VgButtonGroupFixed.vue?vue&type=template&id=2e1af98a&scoped=true&"
import script from "./VgButtonGroupFixed.vue?vue&type=script&lang=js&"
export * from "./VgButtonGroupFixed.vue?vue&type=script&lang=js&"
import style0 from "./VgButtonGroupFixed.vue?vue&type=style&index=0&id=2e1af98a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1af98a",
  null
  
)

export default component.exports